import React from 'react';
import { motion } from 'framer-motion';
import { XOctagon, Lightbulb } from 'lucide-react';
export function WhyMethodsFail() {
  const methods = [{
    title: 'Cursos genéricos',
    desc: 'Demasiado teórico, sin aplicación práctica real'
  }, {
    title: 'Videos de YouTube',
    desc: 'Información fragmentada, sin sistema claro'
  }, {
    title: 'Mentores costosos',
    desc: 'Inaccesibles para quien está empezando'
  }, {
    title: 'Prueba y error',
    desc: 'Tarda años y quema presupuesto'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-194">
      <div className="max-w-5xl mx-auto" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-196">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-197">
            Por Qué Los Métodos Anteriores{' '}
            <span className="text-red-400" data-id="element-198">Te Fallaron</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-199">
            Antes de presentarte la solución, necesitas entender algo
            importante:{' '}
            <strong className="text-white" data-id="element-200">
              No fallaste tú. Fallaron las herramientas que te dieron.
            </strong>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-201">
          {methods.map((method, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-navy-900 border border-white/5 p-6 rounded-xl flex items-start space-x-4" data-id="element-202">
              <div className="mt-1 flex-shrink-0" data-id="element-203">
                <XOctagon className="w-6 h-6 text-red-500/70" data-id="element-204" />
              </div>
              <div data-id="element-205">
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-206">
                  {method.title}
                </h4>
                <p className="text-slate-400" data-id="element-207">{method.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="relative bg-gradient-to-br from-navy-800 to-navy-900 p-8 sm:p-10 rounded-2xl border border-gold-500/30 box-glow text-center" data-id="element-208">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-navy-950 rounded-full border border-gold-500/30 flex items-center justify-center" data-id="element-209">
            <Lightbulb className="w-6 h-6 text-gold-400" data-id="element-210" />
          </div>
          <p className="text-xl sm:text-2xl font-serif text-white leading-relaxed mt-4" data-id="element-211">
            La razón real por la que los afiliados y coaches no generan
            resultados no es la falta de tráfico.{' '}
            <span className="text-gold-400 font-medium" data-id="element-212">
              Es la ausencia de un sistema de promoción coherente, paso a paso,
              que conecte cada pieza.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}